var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2973)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2973)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 6H14C11.7909 6 10 7.79086 10 10V28C10 30.2091 11.7909 32 14 32H32C34.2091 32 36 30.2091 36 28V10C36 7.79086 34.2091 6 32 6Z",
    fill: "#AA701A"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M32 2H14C11.7909 2 10 3.79086 10 6V24C10 26.2091 11.7909 28 14 28H32C34.2091 28 36 26.2091 36 24V6C36 3.79086 34.2091 2 32 2Z",
    fill: "#CC962C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0806 20.15C17.2706 20.15 16.6506 19.92 16.2206 19.46C15.7906 19 15.5756 18.35 15.5756 17.51V11.99C15.5756 11.15 15.7906 10.5 16.2206 10.04C16.6506 9.58 17.2706 9.35 18.0806 9.35C18.8906 9.35 19.5106 9.58 19.9406 10.04C20.3706 10.5 20.5856 11.15 20.5856 11.99V17.51C20.5856 18.35 20.3706 19 19.9406 19.46C19.5106 19.92 18.8906 20.15 18.0806 20.15ZM18.0806 18.65C18.6506 18.65 18.9356 18.305 18.9356 17.615V11.885C18.9356 11.195 18.6506 10.85 18.0806 10.85C17.5106 10.85 17.2256 11.195 17.2256 11.885V17.615C17.2256 18.305 17.5106 18.65 18.0806 18.65ZM21.7014 18.41H23.2914V20H21.7014V18.41ZM26.8686 20.15C26.0586 20.15 25.4436 19.925 25.0236 19.475C24.6136 19.025 24.4086 18.38 24.4086 17.54V16.685H25.9686V17.615C25.9686 18.305 26.2536 18.65 26.8236 18.65C27.1036 18.65 27.3136 18.565 27.4536 18.395C27.6036 18.215 27.6786 17.905 27.6786 17.465V16.61C27.6786 16.13 27.5936 15.79 27.4236 15.59C27.2536 15.38 26.9786 15.275 26.5986 15.275H26.0436V13.775H26.6436C26.9736 13.775 27.2186 13.69 27.3786 13.52C27.5486 13.35 27.6336 13.065 27.6336 12.665V11.9C27.6336 11.54 27.5586 11.275 27.4086 11.105C27.2586 10.935 27.0586 10.85 26.8086 10.85C26.2786 10.85 26.0136 11.175 26.0136 11.825V12.515H24.4536V11.96C24.4536 11.12 24.6586 10.475 25.0686 10.025C25.4886 9.575 26.0886 9.35 26.8686 9.35C27.6586 9.35 28.2586 9.575 28.6686 10.025C29.0786 10.465 29.2836 11.105 29.2836 11.945V12.32C29.2836 12.89 29.1886 13.35 28.9986 13.7C28.8086 14.04 28.5136 14.285 28.1136 14.435V14.465C28.5436 14.625 28.8536 14.885 29.0436 15.245C29.2336 15.605 29.3286 16.065 29.3286 16.625V17.555C29.3286 18.395 29.1186 19.04 28.6986 19.49C28.2886 19.93 27.6786 20.15 26.8686 20.15Z",
    fill: "#111820"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2973",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2973"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2973",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 46,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.5c83c2faac5753d08434a334e8ac615d.svg";
export { ForwardRef as ReactComponent };